const summary_cards = [
  { label: 'HSE items', value: '7', note: 'Open this period', accent: 'dark' },
  { label: 'Open incidents', value: '1', note: 'Under corrective action', accent: 'red' },
  { label: 'Inspections due', value: '4', note: 'To complete', accent: 'amber' },
  { label: 'Overdue', value: '1', note: 'Life-safety risk', accent: 'red' }
];

const filters = [
  { id: 'all', label: 'All', count: 7, active: true },
  { id: 'hazards', label: 'Hazards', count: 1 },
  { id: 'incidents', label: 'Incidents', count: 1 },
  { id: 'inspections', label: 'Inspections', count: 4 },
  { id: 'environment', label: 'Environment', count: 1 }
];

const rows_by_tab = {
  all: [
    { ref: 'HS-00', item: 'Warehouse hazard register', site: 'Central warehouse', type: 'Hazard', status: { label: 'Action needed', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'HS-01', item: 'Slip & fall - warehouse floor', site: 'Central warehouse', type: 'Incident', status: { label: 'Corrective action', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'HS-02', item: 'Fire extinguisher inspection', site: 'Soweto clinic', type: 'Inspection', status: { label: 'Overdue', class: 'bg-danger-subtle text-danger-emphasis' } },
    { ref: 'HS-03', item: 'Emergency evacuation drill', site: 'Head office', type: 'Drill', status: { label: 'Scheduled', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'HS-04', item: 'Hazardous waste disposal manifest', site: 'Central warehouse', type: 'Environment', status: { label: 'Compliant', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'HS-05', item: 'PPE stock check', site: 'Soweto clinic', type: 'Inspection', status: { label: 'Action needed', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'HS-06', item: 'Occupational health & safety training', site: 'All sites', type: 'Inspection', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  hazards: [
    { ref: 'HS-00', item: 'Warehouse hazard register', site: 'Central warehouse', type: 'Hazard', status: { label: 'Action needed', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  incidents: [
    { ref: 'HS-01', item: 'Slip & fall - warehouse floor', site: 'Central warehouse', type: 'Incident', status: { label: 'Corrective action', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  inspections: [
    { ref: 'HS-02', item: 'Fire extinguisher inspection', site: 'Soweto clinic', type: 'Inspection', status: { label: 'Overdue', class: 'bg-danger-subtle text-danger-emphasis' } },
    { ref: 'HS-03', item: 'Emergency evacuation drill', site: 'Head office', type: 'Drill', status: { label: 'Scheduled', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'HS-05', item: 'PPE stock check', site: 'Soweto clinic', type: 'Inspection', status: { label: 'Action needed', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'HS-06', item: 'Occupational health & safety training', site: 'All sites', type: 'Inspection', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  environment: [
    { ref: 'HS-04', item: 'Hazardous waste disposal manifest', site: 'Central warehouse', type: 'Environment', status: { label: 'Compliant', class: 'bg-success-subtle text-success-emphasis' } }
  ]
};

export default {
  name: 'ComplyonHealthSafetyEnvironment',
  data: () => ({
    summary_cards,
    filters,
    active_tab: 'all',
    rows_by_tab
  }),
  computed: {
    rows() {
      return this.rows_by_tab[this.active_tab] || this.rows_by_tab.all;
    }
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
      this.filters = this.filters.map((filter) => ({ ...filter, active: filter.id === tab_id }));
    }
  }
};
